/**
 * 通用 API
 */

import http from '~/utils/http'
import type { HttpResponse } from '~/types/http'
import type {
  GetHomeAnnouncementParams, HomeAnnouncementResponse,
  GetRecommendedSongsListParams, RecommendedSongsResponse,
  GetTrendingSongsListParams, TrendingSongsResponse,
  GetNewSongsListParams, NewSongsResponse
} from '~/types/home'

/**
 * 获取首页公告
 */
export async function getHomeAnnouncement(params: GetHomeAnnouncementParams): Promise<HttpResponse<HomeAnnouncementResponse>> {
  return http.get('/autoreply/queryCMS', {
    params,
    showSuccess: false,
    loading: true
  })
}

/**
 * 获取推荐音乐列表
 */
export async function getRecommendedSongsList(params: GetRecommendedSongsListParams): Promise<HttpResponse<RecommendedSongsResponse>> {
  return http.get('/queue/getRecClips', {
    params,
    showSuccess: false,
    loading: true
  })
}

/**
 * 获取热门音乐列表
 */
export async function getTrendingSongsList(params: GetTrendingSongsListParams): Promise<HttpResponse<TrendingSongsResponse>> {
  return http.get('/queue/getHotClips', {
    params,
    showSuccess: false,
    loading: true
  })
}

/**
 * 获取最新歌曲列表
 */
export async function getNewSongsList(params: GetNewSongsListParams): Promise<HttpResponse<NewSongsResponse>> {
  return http.get('/queue/getNewClips', {
    params,
    showSuccess: false,
    loading: true
  })
}
